'use client';

import { ChatBubbleLeftEllipsisIcon } from '@heroicons/react/24/outline';
import { Post } from '@prisma/client';
import Image from 'next/image';
import Link from 'next/link';

import { blurDataURL } from '@/shared/lib';

export default function DisplayPostItem(props: {
  post: Post & { commentsCount: number };
  imageUrl: string | undefined;
}) {
  const { post, imageUrl } = props;

  return (
    <section
      key={post.id}
      className="grid rounded-md bg-slate-300 drop-shadow-md dark:bg-slate-700 dark:shadow-slate-100"
    >
      <Link href={`/posts/${post.id}`}>
        <Image
          className="m-auto h-auto rounded-md pb-2 md:pb-8"
          alt={post.coverPicture ?? '/broken-image.svg'}
          src={imageUrl ?? blurDataURL}
          width={1920 / 3}
          height={1280 / 3}
          quality={70}
          loading="lazy"
          placeholder="blur"
          blurDataURL={blurDataURL}
          sizes="(max-width: 768px) 45vw, 50vw"
        />
      </Link>
      <div className="px-4">
        <h1 className="pb-2 text-2xl font-bold">{post.metaTitle}</h1>
        <p>{post.metaDescription}</p>
      </div>
      <div className="-mt-20 grid grid-cols-2 items-center gap-4 rounded-b-md bg-linear-to-t from-slate-400 via-slate-400 p-6 md:-mt-10 dark:from-slate-800 dark:via-slate-800">
        <div className="flex items-center">
          <ChatBubbleLeftEllipsisIcon width={24} height={24} />
          &nbsp;&nbsp;
          <p>{post.commentsCount}</p>
        </div>
        <Link
          as={`/posts/${post.id}`}
          href="/posts/[slug]"
          className="transform rounded-sm bg-yellow-300 px-4 py-2 text-center transition-transform active:scale-95 dark:bg-yellow-600"
        >
          Читать
        </Link>
      </div>
    </section>
  );
}
